module.exports = __webpack_public_path__ + "img/KinokoTable08.a39ed7da.jpg";